function buildNutritiousDiningMenuRows(menuScreenInfo) {
    if (!menuScreenInfo || !Array.isArray(menuScreenInfo.menuList)) {
        return [];
    }

    function getWeekLabel(dateText) {
        if (!dateText) {
            return '';
        }

        const parts = String(dateText).split('-');
        if (parts.length !== 3) {
            return '';
        }

        const normalized = parts.join('/');
        const date = new Date(normalized);
        if (Number.isNaN(date.getTime())) {
            return '';
        }

        const day = date.getDay();
        const weekDay = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        return weekDay[day] || '';
    }

    return menuScreenInfo.menuList
        .map((row) => {
            if (!row || typeof row !== 'object') {
                return null;
            }

            const date = String(row.validPeriodDate || '').trim();
            if (!date) {
                return null;
            }

            return {
                date,
                week: getWeekLabel(date),
                rice: String(row.riceMenuInfo || '').trim(),
                meat1: String(row.oneMeatMenuInfo || '').trim(),
                meat2: String(row.towMeatMenuInfo || '').trim(),
                vegetable: String(row.vegetableMenuInfo || '').trim(),
            };
        })
        .filter(Boolean);
}

module.exports = {
    buildNutritiousDiningMenuRows,
};
